import { useEffect, useState } from "react";
import axios from "axios";
import { Clock, Truck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ExpressBadge = ({ status, variant = "light", className = "" }) => {
  const [data, setData] = useState(status || null);

  useEffect(() => {
    if (status) { setData(status); return; }
    axios.get(`${API}/geo/express-status`).then(r => setData(r.data)).catch(() => {});
  }, [status]);

  if (!data) return null;
  const dark = variant === "dark";
  const Icon = data.available ? Truck : Clock;
  return (
    <div
      className={`inline-flex items-center gap-2.5 rounded-full pl-1.5 pr-4 py-1.5 backdrop-blur-md border ${dark ? "bg-black/40 border-white/15 text-white" : "bg-white border-[#7A8C69]/15 text-forest shadow-sm"} ${className}`}
      data-testid="express-badge"
      data-available={data.available}
    >
      <span className={`flex h-7 w-7 items-center justify-center rounded-full ${data.available ? "bg-[#7fb241] text-white" : dark ? "bg-white/15 text-white" : "bg-cream-dark text-forest"}`}>
        <Icon className="h-3.5 w-3.5" />
      </span>
      <span className="leading-tight">
        <span className="block text-xs sm:text-sm font-semibold">{data.label}</span>
        <span className={`block text-[10px] sm:text-[11px] ${dark ? "text-white/70" : "text-sage"}`}>{data.sub}</span>
      </span>
      {data.available && <span className="relative flex h-2 w-2 ml-1"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7fb241] opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-[#7fb241]" /></span>}
    </div>
  );
};

export default ExpressBadge;
